import axios from 'axios'
import {
  PostAgentPromptRequest,
  PostAgentPromptResponse,
} from 'src/queries/agent/network/agent.models'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'
import { ExtendThreadIDHeader } from 'src/queries/requestConfig.models'

export const postAgentPrompt = async (
  req: PostAgentPromptRequest,
): Promise<PostAgentPromptResponse> => {
  const requestConfig = getRequestConfig(RequestConfig.Agent)

  const { threadId, ...reqRest } = req
  requestConfig.headers = {
    ...requestConfig.headers,
    [ExtendThreadIDHeader]: threadId ?? '',
  }

  const response = await axios.post<PostAgentPromptResponse>(
    '/prompt',
    reqRest,
    requestConfig,
  )

  const responseThreadId = (response?.headers?.[
    ExtendThreadIDHeader.toLowerCase()
  ] ?? req.threadId) as string
  if (responseThreadId === undefined)
    throw new Error(
      'postPromptAgentStream: no thread_id returned from response',
    )

  return {
    ...response.data,
    threadId: responseThreadId,
  }
}

export function assertNever(value: never, tag?: string): never {
  throw new Error(`assertNever ${tag ?? ''} - Unexpected value: ${value}`)
}
